import { ADVANCED_SETTINGS_PATH } from 'shared/constants/availability_browser_urls'

const CALENDAR_SETTINGS_SECTION = 'calendar'
const ADVANCED_AVAILABILITY_SETTINGS_TAB = 'advanced'

const mergeCalendarAdvancedSettingsSearch = (existingSearch = '') => {
  const params = new URLSearchParams(existingSearch)
  params.set('settings', CALENDAR_SETTINGS_SECTION)
  params.set('settings_tab', ADVANCED_AVAILABILITY_SETTINGS_TAB)
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}

/** Opens Scheduling settings modal → Advanced availability (global meeting limits). */
export const getGlobalLimitsManageNavigationTarget = ({
  pathname,
  search = '',
  hash = '',
  isRebrandSettingsIaEnabled,
}) => {
  if (isRebrandSettingsIaEnabled) {
    return {
      pathname,
      search: mergeCalendarAdvancedSettingsSearch(search),
      hash,
    }
  }

  return ADVANCED_SETTINGS_PATH
}
